/** @format */

import React from "react";
import {
  Navbar,
  Hero,
  FAQ,
  Footer,
  DownloadFitStats,
  Services,
  WhyChooseUs,
  Gallery,
  Reviews 
} from "../components";

const Landing = () => {
  return (
    <div>
      <div>
        <Navbar />
        <Hero />
        <DownloadFitStats />
        <Services />
        <WhyChooseUs />
        <Gallery />
        <Reviews />
        <FAQ />
         <Footer />
      </div>
      </div>
  );
};

export default Landing;
